<template>
  <div class="reject__form">
    <h2>Описание изменений</h2>
    <p>Опишите изменения, которые Вы внесли в проект.</p>
    <a-form
      class="form"
      :model="model"
      :rules="rules"
      @validate="errors.onValidate"
      @finish="onFinish"
    >
      <a-form-item
        name="comment"
        :help="errors.getError('comment')"
        :validate-status="errors.getStatus('comment')"
      >
        <a-textarea
          class="form__textarea"
          id="reApprovalComment"
          v-model:value="model.comment"
          placeholder="Укажите корректировки здесь"
        />
      </a-form-item>
      <a-form-item class="reject__form-button">
        <c-button-danger :loading="isLoading" html-type="submit">
          Отправить на согласование
        </c-button-danger>
      </a-form-item>
    </a-form>
  </div>
</template>

<script setup>
  import { reactive, ref } from 'vue';
  import { useApi } from '@/api/use-api';
  import ErrorsHandler from '@/components/form/errors-handler';
  import CButtonDanger from '@/components/UI/CButtonDanger';
  import { TEXT_LENGTH_ERROR } from '@/constants/error';

  const api = useApi();
  const emit = defineEmits(['close', 'update']);
  const isLoading = ref(false);

  const props = defineProps({
    changedApproval: {
      type: Object,
      required: true,
    },
  });

  const model = reactive({
    comment: '',
  });

  const rules = {
    comment: [
      {
        type: 'string',
        required: false,
        min: 2,
        max: 5000,
        message: TEXT_LENGTH_ERROR,
        trigger: 'change',
      },
    ],
  };

  const errors = new ErrorsHandler(
    {
      comment: '',
    },
    (fieldName) => {
      if ('approval' === fieldName) {
        return 'comment';
      }
      return fieldName;
    }
  );

  const onFinish = async () => {
    isLoading.value = true;
    try {
      await api.leaderPage.reApproveProject({
        projectApprovalId: props.changedApproval.id,
        comment: model.comment,
      });
      emit('update');
      emit('close');
    } catch (error) {
      errors.handleApiErrors(error);
    } finally {
      isLoading.value = false;
    }
  };
</script>

<style lang="scss" scoped>
  @use "@/assets/styles/_colors.scss" as *;

  * {
    margin: 0;
  }

  .reject__form {
    padding: 112px 17px 0 17px;

    h2 {
      font: 700 18px/26px 'Nunito Sans';
    }

    p {
      margin-top: 21px;
    }

    .form {
      margin-top: 30px;

      &__textarea {
        min-height: 125px;
        resize: none;
      }
    }

    &-button {
      margin-top: 50px;
      text-align: right;
    }
  }
</style>
